<template>
    <div class="stepper-header">
        <div v-for="(step, index) in steps" :key="step.value" class="stepper-header__item" :class="{
            'stepper-header__item--active': currentStep === step.value,
            'stepper-header__item--completed': currentStep > step.value,
            'stepper-header__item--clickable': clickable
        }" @click="onStepClick(step.value)">
            <div class="stepper-header__step">
                <v-icon :color="getIconColor(step.value)" size="18">
                    {{ step.icon }}
                </v-icon>
                <span class="stepper-header__label">{{ step.value }}. {{ step.label }}</span>
            </div>
            <div class="stepper-header__underline"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'StepperHeader',
    props: {
        steps: {
            type: Array,
            required: true,
            // Expected format: [{ value: 1, label: 'Step 1', icon: 'mdi-icon-name' }]
        },
        currentStep: {
            type: Number,
            default: 1
        },
        clickable: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        getIconColor(stepValue) {
            if (this.currentStep === stepValue) {
                return '#1976D2';
            }
            return '#9E9E9E';
        },
        onStepClick(stepValue) {
            if (this.clickable && stepValue <= this.currentStep) {
                this.$emit('step-click', stepValue);
            }
        }
    }
}
</script>

<style scoped>
.stepper-header {
    display: flex;
    align-items: stretch;
    background: #fff;
    border-bottom: 1px solid #E0E0E0;
}

.stepper-header__item {
    display: flex;
    flex-direction: column;
    flex: 1;
    padding: 16px 24px 0;
    cursor: default;
}

.stepper-header__item--clickable {
    cursor: pointer;
}
.stepper-header__step {
    display: flex;
    align-items: center;
    gap: 8px;
    white-space: nowrap;
    padding-bottom: 12px;
}

.stepper-header__label {
    font-size: 14px;
    font-weight: 700;
    color: #3F3F3F;
}

.stepper-header__item--active .stepper-header__label {
    color: #1976D2;
}

.stepper-header__underline {
    height: 3px;
    background: transparent;
    margin: 0 -24px;
}

.stepper-header__item--active .stepper-header__underline {
    background: #1976D2;
}
</style>
